import React from 'react';
import {
    Grid,
    GridSize,
    InputAdornment,
    StandardTextFieldProps,
    TextField
} from '@mui/material';

export type InputEventProps = React.ChangeEvent<HTMLInputElement>;

export interface FieldProps extends StandardTextFieldProps {
    sx?: React.CSSProperties | undefined;
    lg?: boolean | GridSize | undefined;
    md?: boolean | GridSize | undefined;
    sm?: boolean | GridSize | undefined;
    xs?: boolean | GridSize | undefined;
    fieldVariant?: 'outlined' | 'standard' | 'filled' | undefined;
    optional?: boolean | undefined;
    endAdornment?: React.ReactNode;
    children?: React.ReactNode;
}

export const Field: React.FC<FieldProps> = React.memo(
    ({
        sx,
        xs,
        sm,
        md,
        lg,
        fieldVariant,
        optional,
        endAdornment,
        children,
        ...otherProps
    }) => {
        return (
            <Grid item xs={xs ? xs : 12} sm={sm} md={md} lg={lg}>
                <TextField
                    fullWidth
                    {...otherProps}
                    InputProps={{
                        endAdornment: endAdornment && (
                            <InputAdornment position='end'>
                                {endAdornment}
                            </InputAdornment>
                        )
                    }}
                    label={`${
                        otherProps.label ? otherProps.label : otherProps.name
                    }:`}
                    variant={fieldVariant}
                    required={!optional}
                    style={sx}
                >
                    {children}
                </TextField>
            </Grid>
        );
    }
);
